import { render } from "./OrderRow.vue?vue&type=template&id=453d55c6&scoped=true"
import script from "./OrderRow.vue?vue&type=script&lang=ts"
export * from "./OrderRow.vue?vue&type=script&lang=ts"

import "./OrderRow.vue?vue&type=style&index=0&id=453d55c6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-453d55c6"

export default script